import apiClient from '@/utils/axios'
import {apiEndPoints} from '@/utils/constant'
import {Action, Model, Permission} from '@/types'
import {AxiosResponse} from 'axios'

const {PERMISSION_URL} = apiEndPoints

interface PermissionService{
  getPermissions: () => Promise<AxiosResponse<Permission[]>>
  getActions: () => Promise<AxiosResponse<Action>>
  getModels: () => Promise<AxiosResponse<Model>>
  getPermissionById: (permissionId: number) => Promise<AxiosResponse<Permission>>
  postPermissions: (permission: Permission) => Promise<AxiosResponse<Permission>>
  deletePermission: (permissionId: number) => Promise<AxiosResponse<string>>
}

const permission: PermissionService = {
  async getPermissions(): Promise<AxiosResponse<Permission[]>> {
    const response = await apiClient.get(PERMISSION_URL)
    return response
  },

  async getActions(): Promise<AxiosResponse<Action>> {
    const response = await apiClient.get('/action')
    return response
  },

  async getModels(): Promise<AxiosResponse<Model>> {
    const response = await apiClient.get('/model')
    return response
  },

  async getPermissionById(permissionId: number): Promise<AxiosResponse<Permission>> {
    const response = await apiClient.get(`${PERMISSION_URL}/${permissionId}`)
    return response
  },

  async postPermissions(permission: Permission): Promise<AxiosResponse<Permission>> {
    const response = await apiClient.post(PERMISSION_URL, permission)
    return response
  },

  async deletePermission(permissionId: number): Promise<AxiosResponse<string>> {
    const response = await apiClient.delete(
      `${PERMISSION_URL}/${permissionId}`,
    )
    return response
  },
}

export {permission}
